export var PLAY_SOUND_SESSION_STORE_SOUND = "PLAY_SOUND_SESSION_STORE_SOUND";
export var PLAY_SOUND_SESSION_START = "PLAY_SOUND_SESSION_START";
export var PLAY_SOUND_SESSION_PROGRESS = "PLAY_SOUND_SESSION_PROGRESS";
export var PLAY_SOUND_SESSION_END = "PLAY_SOUND_SESSION_END";